import * as d3 from 'd3';

export function drawHanger(svg, x, y, width, height, color = 'white', borderColor = 'black', borderWidth = 0.2) {
    const inset = width * 0.25; // Controls the inner rectangle thickness
  
    // Outer rectangle (background, typically white)
    svg.append('rect')
      .attr('x', x)
      .attr('y', y - height/2)
      .attr('width', width)
      .attr('height', height)
      .attr('fill', color)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);

    const w = 0.6*width;
    const offsetX = (width-w)/2;  
      svg.append('rect')
      .attr('x', x + offsetX)
      .attr('y', y )
      .attr('width', w)
      .attr('height', 1.5*height)
      .attr('fill', 'lightgrey')
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  
    // Inner rectangle (handle, black or grey)
  /*  svg.append('rect')
      .attr('x', x + inset)
      .attr('y', y)
      .attr('width', width - 2 * inset)
      .attr('height', height)
      .attr('fill', 'lightgrey');*/
  }
  
  /*
     svg.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
      */